export const INCREASE = "INCREASE";
export const DECREASE = "DECREASE";
export const REMOVE = "REMOVE";
export const CLEAR_CART = "CLEAR_CART";
export const GET_ITEM_TOTAL = "GET_TOTAL";
export const GET_TOTAL_AMOUNT = "GET_AMOUNT";
